import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as o, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMonitor",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h8a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 2H2Zm4.5 7H10a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 10 1H2A1.5 1.5 0 0 0 .5 2.5v5A1.5 1.5 0 0 0 2 9h3.5v1H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6.5V9Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, h, i, f, p, a) {
  return o(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--monitor"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Monitor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const A = /* @__PURE__ */ l(s, [["render", u]]);
export {
  A as default
};
//# sourceMappingURL=monitor.js.map
